export default __webpack_public_path__ + "static/media/descargacfdi.9d38d1aa.svg";